module.exports = __webpack_public_path__ + "img/pencils.a7c24a7c.svg";